import React from 'react';
import { SemanticInformationType } from '../utilities/types';
import { style } from 'typestyle';
import { spacing } from '../../../theme/spacing';
import { borderRadius } from '../../../theme/border';
import { rebrand } from '../../../theme/color';
import { centerCenter, flexRoot } from 'csstips';
import { NestedCSSProperties } from 'typestyle/lib/types';

interface PlanFlagProps {
  type: SemanticInformationType | 'primary';
  children: React.ReactNode;
}

const commonStyles: NestedCSSProperties = {
  ...flexRoot,
  ...centerCenter,
  gap: spacing.XSMALL,
  padding: `${spacing.XSMALL} ${spacing.DEFAULT}`,
  borderRadius: borderRadius.MEDIUM,
  fontWeight: 700,
  position: 'absolute',
  top: 0,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'max-content',
  maxWidth: '100%',
  $nest: {
    '& svg': {
      flexShrink: 0,
    },
  },
};

const styles: { [key in SemanticInformationType & 'primary']: string } = {
  [SemanticInformationType.SUCCESS]: style({
    ...commonStyles,
    backgroundColor: '#E0F3F1',
    color: rebrand.secondary[70].toHexString(),
  }),
  [SemanticInformationType.WARNING]: style({
    ...commonStyles,
    backgroundColor: rebrand.semantic.warning[20].toHexString(),
    color: rebrand.semantic.warning[60].toHexString(),
  }),
  [SemanticInformationType.ERROR]: style({
    ...commonStyles,
    backgroundColor: rebrand.semantic.error[10].toHexString(),
    color: rebrand.semantic.error[90].toString(),
  }),
  [SemanticInformationType.INFO]: style({
    ...commonStyles,
    backgroundColor: rebrand.neutralOnDark[20].toHexString(),
  }),
  primary: style({
    ...commonStyles,
    backgroundColor: rebrand.primary[50].toHexString(),
  }),
};

export const PlanFlag: React.FC<PlanFlagProps> = ({ type, children, ...rest }) => {
  const wrapperStyles = styles[type];

  return (
    <div className={wrapperStyles} {...rest}>
      {children}
    </div>
  );
};
